import type { SimilarityProject } from "../../api/similarity";
import { ProjectCollection } from "../../components/ToolPage";
import RecentComparisons from "./RecentComparisons";
export default function SimilarityProjectList({
  projects,
  error,
  onRetry,
  onCreate,
  onDelete,
}: {
  projects: SimilarityProject[];
  error?: string | null;
  onRetry: () => void;
  onCreate: (p: SimilarityProject) => void;
  onDelete: (p: SimilarityProject) => void;
}) {
  return (
    <ProjectCollection
      toolId="similarity"
      error={error}
      onRetry={onRetry}
      recent={<RecentComparisons />}
      recentLabel="Recent comparisons"
      items={projects.map((p) => ({
        id: p.id,
        title: p.name,
        href: `/similarity/${encodeURIComponent(p.id)}`,
        updatedAt: p.updated_at || p.created_at,
        metadata: [
          { label: "Threshold", value: p.settings.similarity_threshold },
          { label: "Max comparisons", value: p.settings.max_comparisons },
        ],
        actions: [
          { label: "Run comparison", onSelect: () => onCreate(p) },
          { label: "Delete project", onSelect: () => onDelete(p) },
        ],
      }))}
    />
  );
}
